import React from "react";

export const About = () => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="img/about.webp" className="img-responsive" alt="About Us" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>At Altrange, we bridge the gap between construction businesses and top cement manufacturers, ensuring seamless, cost-effective bulk supplies. As a B2B middleman, we connect clients directly to parent companies, eliminating unnecessary costs while maintaining premium quality. Our platform handles the entire process, from order placement to delivery and after-sales support. Whether through our site or app, clients can easily place orders, make payments, and receive timely deliveries straight to their project sites. With Altrange, construction procurement becomes hassle-free, efficient, and cost-saving.</p>
              <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>Direct Manufacturer Pricing – No middle-layer cost</li>
                    <li>Bulk Non-Trade Supplies – Best deals for large orders</li>
                    <li>End-to-End Process Handling – From order to delivery</li>
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    <li>Easy Online & On-Site Ordering – Simple & convenient</li>
                    <li>Reliable Customer Support – Before & after sales</li>
                    <li>Fast & Hassle-Free Delivery – Straight to your site</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
